import { render, staticRenderFns } from "./PrivateProfile.vue?vue&type=template&id=e8fa2a4e&"
import script from "./PrivateProfile.vue?vue&type=script&lang=js&"
export * from "./PrivateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports